import React from "react";
import { useTranslation } from "react-i18next";
import Field from "./field";
import { Profile } from "../../../types/types";
import { convertToYouTubeEmbedUrl } from "../../../utils/utilMethods";

interface YouTubeLinksProps {
    member: Profile;
}

const YouTubeLinks: React.FC<YouTubeLinksProps> = ({ member }) => {
    const { t } = useTranslation('publicProfile');
    if (!member.fighter) return null;

    return (
        <div className="space-y-4 pb-8">
            <h3 className="text-base font-semibold text-gray-800 border-b pb-2">
                {t("youtube_links")}
            </h3>
            {member.fighter.ytLinksDetails?.length ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {member.fighter.ytLinksDetails.map((link: any, index: any) => {
                        const embedUrl = convertToYouTubeEmbedUrl(link.ytLink);
                        return (
                            <div
                                key={index}
                                className="border rounded-lg p-4 bg-gray-50"
                            >
                                <div className="space-y-3 text-start">
                                    <Field label="title" value={link.shortTitle} />
                                    <Field
                                        label="description"
                                        value={link.shortDescription}
                                    />
                                    {embedUrl ? (
                                        <div className="aspect-video w-full">
                                            <iframe
                                                className="w-full h-full rounded-md"
                                                src={embedUrl}
                                                title={`YouTube video player - ${link.shortTitle}`}
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    ) : (
                                        <p className="text-sm text-red-500">
                                            {t("invalid_youtube_url")}
                                        </p>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p className="text-gray-500 text-center py-8">
                    {t("no_youtube_links")}
                </p>
            )}
        </div>
    );
};

export default YouTubeLinks;
